import { render, staticRenderFns } from "./MaterialsDownload.vue?vue&type=template&id=0d85f70b&scoped=true"
import script from "./MaterialsDownload.vue?vue&type=script&lang=js"
export * from "./MaterialsDownload.vue?vue&type=script&lang=js"
import style0 from "./MaterialsDownload.vue?vue&type=style&index=0&id=0d85f70b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d85f70b",
  null
  
)

export default component.exports